import {
  fadeIn,
  fadeInDown,
  fadeInLeft,
  fadeInRight,
  fadeInUp,
} from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../assets/styles/colors";

const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;
const fadeInUpAnimation = keyframes`${fadeInUp}`;
const fadeInAnimation = keyframes`${fadeIn}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const Container = styled.div`
  margin-top: 105px;
`;

export const CardContainerFood = styled.div`
  display: block;
  animation: 1s
    ${(props) => (props.sel ? fadeInLeftAnimation : fadeInRightAnimation)};
`;

export const ElementTitle = styled.div`
  padding: 7px;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.colorWhite : Color.textColorBlackFor};
  font-size: 18px;
  box-shadow: ${(props) =>
    props.theme.isDarkTheme ? "0 0 4px 2px #282828" : "0 0 4px 2px #ececec"};
  background-color: ${(props) =>
    props.theme.isDarkTheme ? Color.colorDarkOne : Color.colorWhite};
  animation: 1s ${fadeInDownAnimation};
`;

export const ContainerFood = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const ContainerQuantity = styled.div`
  position: absolute;
  bottom: 15px;
  left: 10px;
`;

export const CardLink = styled.a``;

export const FoodImg = styled.img`
  display: ${(props) => (props.isLoading ? "none" : "block")};
  max-height: 100px;
  max-width: 100px;
  margin: auto;
`;

export const FoodName = styled.div`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackFor};
`;

export const FoodPrice = styled.div`
  font-weight: bold;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackSeven : Color.colorRed};
`;

export const FoodPriceDis = styled.span`
  font-size: 11px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackEight
      : Color.textColorBlackFor};
`;

export const CartButton = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 0;
  rught: 0;
  animation: 1s ${fadeInUpAnimation};
`;

export const CartIcon = styled.div`
  background: linear-gradient(-60deg, #ef4123 0%, #ef2379 100%);
  padding: 8px 15px;
  border-radius: 50%;
  color: #fff;
`;

export const BadgeCarts = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 47px;
  right: 15px;
  color: #fff !important;
  background-color: #242424;
  padding: 5px;
`;

export const LoadingContainer = styled.div`
  display: ${(props) => (props.isLoading ? "block" : "none")};
`;

export const FoodOfferPercent = styled.div`
  border: 1px solid ${Color.colorAppOrange};
  padding: 4px;
  border-radius: 6px;
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
  font-weight: bold;
`;

export const FoodDescription = styled.div`
  font-size: 10px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackFor};
  overflow-wrap: break-word;
`;

export const LoadingCardContainer = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const LoadingCard = styled.div`
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
